import React, {useEffect, Fragment, useCallback} from "react";
import {useTranslation} from "react-i18next";
import DataTable from "../../../../components/DataTable/DataTable";
import QueueService from "../../../../services/QueueService/QueueService";
import {Link} from "react-router-dom";
import ArrowDropDownCircleOutlinedIcon from '@material-ui/icons/ArrowDropDownCircleOutlined';
import {handleSortOrder} from "../../../../helpers/helper";
import Tooltip from '@material-ui/core/Tooltip';
import {useRecoilValue} from 'recoil';
import {pendingListState} from '../../../../recoil-store/recoil-state';

function PendingMonitor(props) {
    const {t} = useTranslation();
    const pendingList = useRecoilValue(pendingListState);
    const {
        loading,
        setSearchKeyData,
        setSearchData,
        searchData,
        setCustomColumn,
        customColumn,
    } = props;

    useEffect(() => {
        setSearchData(pendingList);
    }, [pendingList, setSearchData]);


    // Checking the order we have up or down, the data in that order and sending it to the backend

    const handleClick = useCallback(async (data, clickIndex, operation) => {
        const editData = handleSortOrder(
            "PENDING",
            data,
            clickIndex,
            operation
        );
        const response = await QueueService.updateSortOrder(editData);
        if (response) {
            //incoming data control
            if (response?.status) setSearchData(searchData);
        } else {
            console.log("error !");
        }
    }, [searchData, setSearchData])


    useEffect(() => {
        const column = [
            {
                id: -1,
                label: "",
                name: "",
                options: {
                    filter: false,
                    sort: false,
                },
            },
            {
                id: 0,
                label: " ",
                name: "id",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return <span>{dataIndex + 1}.</span>;
                        }
                    },
                },
            },
            {
                id: 1,
                name: "name",
                label: t("MESSAGES.MONITORING.AUTOM-NAME"),
                options: {
                    filter: true,
                    sort: true,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return (
                                <div>
                                    {
                                        <Link
                                            data-test="credential-link"
                                            to={`/dashboard/monitoring/${searchData[dataIndex].id}`}
                                        >
                                            {searchData[dataIndex]?.name}
                                        </Link>
                                    }
                                </div>
                            );
                        }
                    },
                },
            },
            {
                id: 2,
                name: "run_by",
                label: t("MESSAGES.MONITORING.RUN-BY"),
                options: {filter: true, sort: false},
            },
            {
                id: 3,
                name: "mate_name",
                label: t("MESSAGES.MONITORING.MATE-NAME"),
                options: {filter: true, sort: true},
            },
            {
                id: 4,
                name: "type",
                label: t("MESSAGES.MONITORING.TYPE"),
                options: {filter: true, sort: true},
            },
            {
                id: 5,
                name: "updated_at",
                label: t("MESSAGES.MONITORING.UPDATED-AT"),
                options: {filter: true, sort: true, display: false},
            },
            {
                id: 6,
                name: "action",
                label: "Action",
                options: {
                    filter: false,
                    sort: false,
                    customBodyRenderLite: (dataIndex) => {
                        if (searchData && searchData[dataIndex]) {
                            return (
                                // sort order icon
                                <Fragment>
                                    {dataIndex !== 0 && (
                                        <Tooltip title="Increase priority">
                                            <div
                                                onClick={() => handleClick(searchData, dataIndex, "up")}
                                                style={{cursor: "pointer", marginBottom: "-5px"}}
                                            >
                                                <ArrowDropDownCircleOutlinedIcon style={{transform: "rotate(180deg)"}}/>
                                            </div>
                                        </Tooltip>
                                    )}
                                    {dataIndex !== searchData?.length - 1 && (
                                        <Tooltip title="Decrease priority">
                                            <div
                                                onClick={() => handleClick(searchData, dataIndex, "down")}
                                                style={{cursor: "pointer", marginTop: "-10px"}}
                                            >
                                                <ArrowDropDownCircleOutlinedIcon/>
                                            </div>
                                        </Tooltip>
                                    )}
                                </Fragment>
                            );
                        }
                    },
                },
            },
        ];
        setCustomColumn(column);
        setSearchKeyData(["name", "run_by", "mate_name", "type", "updated_at"]);
    }, [searchData, handleClick, setCustomColumn, setSearchKeyData, t]);

    return (
        <div>
            <DataTable
                data={searchData}
                selectableRows={"none"}
                customColumns={customColumn}
                title={t("MESSAGES.MONITORING.AUTOM-MONITORING")}
                loading={loading}
            />
        </div>
    );
}

export default PendingMonitor;
